export class GlobalConstants {

  public static readonly routeStateKey = 'laas_routeState';
  public static readonly languageKey = 'laas_language';
  public static readonly defaultLanguage = 'zh-tw';
  public static readonly cacheKey = 'laas_cache';
  public static readonly currentUser = 'laas_user';
  public static readonly currentToken = 'lass_token';
  public static readonly isEmbedded = 'legacy_is_embedded';
  public static readonly userPreference = 'laas_user_preference';
  public static readonly verificationList = 'verification_list';
  public static readonly menuIconMap = new Map<string, string>([
    ['dolly-flatbed', 'fas fa-dolly-flatbed'],
    ['cog', 'fas fa-cog'],
    ['truck', 'fas fa-truck'],
    ['pallet', 'fas fa-pallet'],
    ['scroll', 'fas fa-scroll'],
    ['box', 'fas fa-box'],
    ['truck-moving', 'fas fa-truck-moving'],
    ['plane-departure', 'fas fa-plane-departure'],
    ['th-list', 'fas fa-th-list'],
    ['envelope', 'fas fa-envelope'],
    ['users', 'fas fa-users'],
    ['plane-departure', 'fas fa-plane-departure'],
    ['th-list', 'fas fa-th-list'],
    ['stamp', 'fas fa-stamp'],
    ['map-marked-alt', 'fas fa-map-marked-alt'],
    ['business-time', 'fas fa-business-time'],
    ['clipboard-list', 'fas fa-clipboard-list'],
    ['plane-arrival', 'fas fa-plane-arrival'],
    ['fa-chart-line', 'fas fa-chart-line'],
    ['wrench', 'fas fa-wrench'],
    ['fa-handshake', 'fas fa-handshake'],
    ['fa-boxes', 'fas fa-boxes'],
    ['file-invoice', 'fas fa-file-invoice'],
    ['file-alt', 'fas fa-file-alt'],
    ['file-excel', 'fas fa-file-excel'],
    ['fa-hands-helping', 'fas fa-hands-helping'],
    ['fa-tasks', 'fas fa-tasks'],
    ['dollar-sign', 'fas fa-dollar-sign'],
    ['fa-file', 'fas fa-file'],
    ['fa-chart-bar', 'fas fa-chart-bar'],
    ['fa-file-invoice', 'fas fa-file-invoice'],
    ['fa-microchip', 'fas fa-microchip'],
    ['fa-star-of-life', 'fas fa-star-of-life'],
    ['fa-chart-area', 'fas fa-chart-area'],
    ['list-alt', 'far fa-list-alt'],
    ['plane-departure', 'fas fa-plane-departure'],
    ['city', 'fas fa-city'],
    ['bullhorn', 'fas fa-bullhorn'],
    ['question', 'far fa-question-circle'],
    ['print', 'fa fa-print'],
    ['warehouse', 'fas fa-warehouse'],
    ['fa-address-card', 'far fa-address-card'],
    ['money-check-dollar', 'fas fa-money-check-dollar'],
    ['plane', 'fas fa-plane'],
    ['file-invoice-dollar', 'fas fa-file-invoice-dollar'],
    ['sack-dollar', 'fas fa-sack-dollar'],
    ['truck-ramp-box', 'fas fa-truck-ramp-box'],
    ['box-archive', 'fas fa-box-archive'],
    ['boxes-stacked', 'fas fa-boxes-stacked'],
    ['circle-question', 'fas fa-circle-question'],
    ['money-bill-transfer', 'fas fa-money-bill-transfer'],
    ['truck-plane', 'fas fa-truck-plane'],
    ['truck-fast', 'fas fa-truck-fast'],
    ['location-dot', 'fas fa-location-dot'],
    ['map-pin', 'fas fa-map-pin'],
    ['plane-up', 'fas fa-plane-up'],
    ['screwdriver-wrench', 'fas fa-screwdriver-wrench'],
    ['users-gear', 'fas fa-users-gear'],
    ['user-tag', 'fas fa-user-tag'],
    ['user-shield', 'fas fa-user-shield'],
    ['tags', 'fas fa-tags'],
    ['envelopes-bulk', 'fas fa-envelopes-bulk'],
    ['list-check', 'fas fa-list-check'],
    ['calculator', 'fas fa-calculator'],
    ['temperature', 'fas fa-thermometer-half'],
    ['full-heart','fa-solid fa-heart'],
    ['empty-heart','fa-regular fa-heart'],
    ['clock', 'far fa-clock'],
    ['broom', 'fas fa-broom'],
    ['info', 'fas fa-info'],
    ['repeat', 'fas fa-repeat'],
    ['rotate-left', 'fas fa-rotate-left'],
    ['check', 'fas fa-check'],
    ['xmark', 'fas fa-xmark'],
    ['floppy-disk', 'fas fa-floppy-disk'],
  ]);
}
